import { render } from "./CreateFeaturingPage.vue?vue&type=template&id=4bab25d4"
import script from "./CreateFeaturingPage.vue?vue&type=script&lang=js"
export * from "./CreateFeaturingPage.vue?vue&type=script&lang=js"

import "./CreateFeaturingPage.vue?vue&type=style&index=0&id=4bab25d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__